"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _templateObject;
function cov_aqtjkw80b() {
  var path = "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/DateLabel.js";
  var hash = "b505d0e2180e71df48f93482360affddae8a0a7c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/DateLabel.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 10,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b505d0e2180e71df48f93482360affddae8a0a7c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_aqtjkw80b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_aqtjkw80b();
var DateToBeConfirmedLabel = (cov_aqtjkw80b().s[0]++, _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: gray;\n  font-style: italic;\n  font-size: ", ";\n  display: block;\n"])), _stylingConstants.default.font.sizeS));
var _default = exports.default = DateToBeConfirmedLabel;